
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
@Component
export default class VueModal extends Vue {
    @Prop({ default: '' }) currentSearchText!: string;
    @Prop({ type: Array, required: false, default: () => { return [] } }) products!: ProductAdmin[];
    @Prop({ type: Array, required: false, default: () => { return [] } }) filteredProducts!: ProductAdmin[];
    isTyping: boolean = false;
    itemId: number = 0;
    get getFilteredProducts(){
        return  this.filteredProducts = this.products.filter(product => {
            return product.product_title?.toLowerCase().includes(this.currentSearchText.toLowerCase())}) || null;
    }
    doSearch(variant_id:number) {
      this.$emit('do-search',variant_id);
      this.currentSearchText = '';
    }
    setProduct(product: ProductAdmin){
        this.currentSearchText = product.product_title! + ' ' + product.variant_title!;
        this.itemId = product.id;
        this.isTyping = false;
    }

};
